// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"6e0f68ab","818":"941a2c8f"}[chunkId] + ".chunk.js";
};